import { useEffect, useState } from "react";
import { Screen } from "../ui/components";
import { Ico } from "../ui/Ico";
import { C, mono } from "../ui/tokens";
import { FUN_FACTS } from "../funFacts";

const FACT_HOLD_MS = 6500;
const FACT_FADE_MS = 320;

function pickRandomIndex(exclude?: number): number {
  if (FUN_FACTS.length <= 1) return 0;
  let next = Math.floor(Math.random() * FUN_FACTS.length);
  if (exclude !== undefined && next === exclude) {
    next = (next + 1) % FUN_FACTS.length;
  }
  return next;
}

export function Analyzing() {
  return (
    <Screen style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ textAlign: "center", width: "100%" }}>
        <div style={{
          margin: "0 auto", width: 80, height: 80, borderRadius: 28,
          background: C.surface, border: `1px solid ${C.border}`,
          display: "flex", alignItems: "center", justifyContent: "center",
          position: "relative",
        }}>
          <div style={{
            position: "absolute", inset: -4, borderRadius: 32,
            background:
              "conic-gradient(from 0deg, transparent 0deg, rgba(255,255,255,0.7) 80deg, transparent 120deg)",
            WebkitMask: "radial-gradient(circle, transparent 36px, #000 37px)",
            mask: "radial-gradient(circle, transparent 36px, #000 37px)",
            animation: "spespin 1.2s linear infinite",
          }} />
          <Ico name="spark" size={32} color={C.fg} />
        </div>
        <div style={{ marginTop: 28, fontSize: 22, fontWeight: 700, letterSpacing: "-0.02em" }}>
          Analysiere Beleg…
        </div>
        <div style={{ marginTop: 8, fontSize: 13, color: C.fg3 }}>
          Händler · Datum · Positionen · MWST
        </div>
        <FunFact />
      </div>
    </Screen>
  );
}

function FunFact() {
  const [idx, setIdx] = useState<number>(() => pickRandomIndex());
  const [opacity, setOpacity] = useState(0);

  // Cycle: paint at opacity 0 → rAF flips to 1 (fade in) → hold → flip to 0
  // (fade out) → transitionend swaps idx → back to fade in.
  //
  // Two effects, each keyed on a single value, so neither one can re-trigger
  // the other mid-transition.
  useEffect(() => {
    // Whenever idx changes (incl. initial mount), schedule a fade-in.
    const id = requestAnimationFrame(() => setOpacity(1));
    return () => cancelAnimationFrame(id);
  }, [idx]);

  useEffect(() => {
    // Once fully visible, hold for FACT_HOLD_MS, then begin the fade-out.
    if (opacity !== 1) return;
    const t = setTimeout(() => setOpacity(0), FACT_HOLD_MS);
    return () => clearTimeout(t);
  }, [opacity]);

  function onFactTransitionEnd(e: React.TransitionEvent<HTMLDivElement>) {
    if (e.propertyName !== "opacity") return;
    // Only act on completed fade-OUTs. Swap idx → the [idx] effect above
    // will schedule the next fade-in.
    if (opacity === 0) setIdx((prev) => pickRandomIndex(prev));
  }

  return (
    <div style={{
      marginTop: 40,
      maxWidth: 320,
      marginLeft: "auto",
      marginRight: "auto",
      textAlign: "center",
    }}>
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
        fontFamily: mono, fontSize: 10, fontWeight: 600,
        letterSpacing: "0.22em", textTransform: "uppercase",
        color: C.fg3,
      }}>
        <Ico name="spark" size={11} color={C.fg3} />
        Wusstest du?
      </div>
      <div
        onTransitionEnd={onFactTransitionEnd}
        style={{
          marginTop: 10,
          fontSize: 13.5,
          lineHeight: 1.55,
          color: C.fg2,
          opacity,
          transition: `opacity ${FACT_FADE_MS}ms ease`,
          minHeight: 80,
          willChange: "opacity",
        }}
      >
        {FUN_FACTS[idx]}
      </div>
    </div>
  );
}
